/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./myPagination.vue?vue&type=template&id=d97be9fe&scoped=true"
import script from "./myPagination.vue?vue&type=script&lang=js"
export * from "./myPagination.vue?vue&type=script&lang=js"
import style0 from "./myPagination.vue?vue&type=style&index=0&id=d97be9fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97be9fe",
  null
  
)

export default component.exports